import { skipToken } from "@reduxjs/toolkit/query";
import type { FC } from "react";
import { useGetTeammateAgentQuery } from "../../api/entities/teammateAgent.js";
import { renderCrumbLabel } from "../../app/navigation/crumbLabel.js";

/** Breadcrumb label for the teammate agent detail page. */
export const TeammateAgentNameCrumbLabel: FC<{
  teammateAgentId: string | undefined;
}> = ({ teammateAgentId }) => {
  const result = useGetTeammateAgentQuery(teammateAgentId ?? skipToken);
  return renderCrumbLabel({
    hasValidId: teammateAgentId !== undefined,
    result,
    buildText: (teammateAgent) => teammateAgent.name,
    fallbackText: "Agent",
  });
};
